import { Drawer } from '@nebula/drawer';
import { TitleLarge500, BodyMedium400, TitleXLarge, BodyLarge } from '@nebula/global-styles';
import styled from 'styled-components';

const tabletLandscapeMin = ({ theme }: { theme: any }) => theme.media.tabletLandscapeMin;
const tabletPortraitMin = ({ theme }: { theme: any }) => theme.media.tabletPortraitMin;

export const ChangePaymentMethodDrawerTitle = styled(TitleLarge500)<{ authorizationPage?: boolean }>`
  @media ${tabletLandscapeMin} {
    ${TitleXLarge};
  }
  ${({ authorizationPage }) => authorizationPage && 'margin-bottom: 1.5rem;'}
`;

export const ChangePaymentMethodDrawerDesc = styled(BodyMedium400)`
  @media ${tabletLandscapeMin} {
    ${BodyLarge};
  }
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const StyledDrawer = styled(Drawer)<{ hideOverflow?: boolean }>`
  height: 90vh;
  ${({ hideOverflow }) =>
    hideOverflow &&
    `
      * {
        overflow: hidden !important;
      }
    `}

  @media ${tabletPortraitMin} {
    height: 100vh;
  }
`;

export const PaymentIcon = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  padding: 0.25rem 0;
`;

export const WarningContainer = styled.div`
  margin-bottom: 1rem;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  height: 300px;
`;
